

import React from 'react'
import classNames from 'classnames'
import ReduxStores from '../../../../stores/connects'
import { bool, string, object, func } from 'prop-types'

class LoginNav extends React.PureComponent {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick (e) {
    const { handleClick, active } = this.props
    e.preventDefault()
    if (active === 'loginNav') handleClick()
    else handleClick('loginNav')
  }

  generateLoginLink () {
    const { pageName, domainSettings, loginConfig } = this.props
    const { customerLoginLocation } = loginConfig
    let referrerLink = ''
    if (domainSettings.domain) {
      referrerLink += (domainSettings.domainScheme ? domainSettings.domainScheme : 'http') + '://'
      referrerLink += domainSettings.domain
    }
    if (pageName) {
      const isHomepage = pageName === 'index' || pageName === 'index-2' || pageName === 'index-3'
      if (!isHomepage) referrerLink += '/' + pageName
      if (!isHomepage && !pageName.match('.html')) referrerLink += '.html'
    }
    if (!referrerLink) return customerLoginLocation
    return customerLoginLocation + '?referrer=' + referrerLink
  }

  render () {
    const { visible, active, loginConfig } = this.props
    const { hideCustomerLogin, header, agentLoginLocation, agentCallToAction, customerTitle, navLoginLink } = loginConfig
    const customerLoginLink = this.generateLoginLink()
    const activeClass = classNames({
      'open': active === 'loginNav',
      'dropdown': true,
      'hidden': !visible
    })
    const singleClass = classNames({
      'ignore-react-onclickoutside': true,
      'single': true
    })

    let navLoginStyling = navLoginLink ? 'navLoginLink' : ''

    if (hideCustomerLogin) {
      return (
        <li className='dropdown-long' id={navLoginStyling}>
          <a className='single' data-hxtrack-name='agent_login' href={agentLoginLocation}>
            <span>{agentCallToAction}</span>
          </a>
        </li>
      )
    }

    return (
      <li className={activeClass} id='navLoginLink'>
        <a href='#' className={singleClass} data-toggle='dropdown' data-hxtrack-name='header_dropdown_login' data-hxtrack-value={active === 'loginNav' ? 'closed' : 'opened'} title='Login' onClick={this.handleClick} target='_parent'>
          { header || 'Login' }
          <span className='caret' />
        </a>
        <ul className='dropdown-menu' role='menu'>
          <li>
            <a data-hxtrack-name='agent_login' href={agentLoginLocation}>{agentCallToAction}</a>
          </li>
          <li>
            <a data-hxtrack-name='login_header_click' href={customerLoginLink} title='Your Account'>{customerTitle}</a>
          </li>
        </ul>
      </li>
    )
  }
}

LoginNav.propTypes = {
  visible: bool,
  active: string,
  pageName: string,
  handleClick: func.isRequired,
  domainSettings: object,
  loginConfig: object
}
LoginNav.defaultProps = {
  visible: true,
  domainSettings: { }
}

export default ReduxStores(LoginNav, ['login'], true)
